import type { ChildProcess } from 'node:child_process';
import { DEFAULT_PREVIEW_ENVIRONMENT_PROCESS_LIFECYCLE } from '../process-lifecycle.js';
import { killPreviewEnvironmentProcessTree } from '../register-exit-cleanup.js';
import { shellSpawn } from '../shell-spawn/index.js';

export type SpawnedPreviewEnvironmentProcess = {
  proc: ChildProcess;
  pipedStdoutStderr: boolean;
  mergedLogPath?: string;
  mergedCleanupDir?: string;
};

export function spawnPreviewEnvironmentProcess(
  cmd: string,
  childEnv: NodeJS.ProcessEnv,
  cwd: string,
  signal: AbortSignal,
): SpawnedPreviewEnvironmentProcess {
  const spawned = shellSpawn(cmd, childEnv, cwd, {
    signal,
    lifecycle: DEFAULT_PREVIEW_ENVIRONMENT_PROCESS_LIFECYCLE,
  });
  return {
    proc: spawned.proc,
    pipedStdoutStderr: spawned.pipedStdoutStderr,
    mergedLogPath: spawned.mergedLogPath,
    mergedCleanupDir: spawned.mergedLogCleanupDir,
  };
}

export function discardStalePreviewEnvironmentSpawn(proc: ChildProcess): void {
  try {
    proc.removeAllListeners();
    killPreviewEnvironmentProcessTree(proc, 'SIGTERM');
  } catch {
    /* ignore */
  }
}
